$(function(){
  const checkboxes = $(".end-user-agreement input[type=checkbox]");
  const acceptButton = $("#accept");

  checkboxes.on("change", function(){
    const allChecked = checkboxes.length === checkboxes.filter(":checked").length;
    acceptButton.attr("disabled", !allChecked);

    if (allChecked) {
      acceptButton.removeAttr("aria-disabled");
    } else {
      acceptButton.attr("aria-disabled", "true");
    }
  });
});
